var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { ContentListApi, TypedStore } from 'sdc-cms-client';
import { publish, subscribe } from 'sdc-publish-subscribe';

export var CmsLabelsStore = function (_TypedStore) {
  _inherits(CmsLabelsStore, _TypedStore);

  function CmsLabelsStore(options) {
    _classCallCheck(this, CmsLabelsStore);

    var _this = _possibleConstructorReturn(this, _TypedStore.call(this, _extends({}, options, {
      listName: 'values'
    })));

    _this.sections = {};

    _this.parseData = function (deferred) {
      return function (payload) {
        _this.parseTranslations(payload.values);
        _this.setEntries(deferred)(payload);
      };
    };

    _this.parseTranslations = function (values) {
      var sections = Object.values(_this.sections).filter(function (s) {
        return s.translations;
      });
      var translated = sections.map(function (s) {
        return s.translations;
      }).reduce(function (acc, tra) {
        return _extends({}, acc, tra);
      }, {});

      var translations = _extends({}, translated, _this.parse(values));

      publish('i18n.translations', translations);
    };

    _this.loadSection = function (key) {
      _this.list({
        params: _this.sections[key],
        callback: _this.parseSection(key)
      })();
    };

    _this.parseSection = function (key) {
      return function (deferred) {
        return function (payload) {
          _this.sections[key].translations = _this.parse(payload.values);
          deferred.resolve(payload.values);
        };
      };
    };

    _this.parse = function (values) {
      var translations = {};
      values.forEach(function (message) {
        translations[message.key] = message.value;
      });
      return translations;
    };

    subscribe('cms-i18n-add-section', function (section) {
      if (section && section.key) {
        _this.sections[section.key] = section;
        _this.loadSection(section.key);
      }
    });
    return _this;
  }

  return CmsLabelsStore;
}(TypedStore);

var makeCmsLabelsStore = function makeCmsLabelsStore(_ref) {
  var backend = _ref.backend,
      accessKey = _ref.accessKey,
      options = _objectWithoutProperties(_ref, ['backend', 'accessKey']);

  return new CmsLabelsStore(_extends({}, options, { api: ContentListApi({ backend: backend, accessKey: accessKey }) }));
};
export { makeCmsLabelsStore };